import { BuilderConfig } from '@/types/Builder';
import B2BAccessHero, { Props } from './b2b-access-hero';

export const B2BAccessHeroBuilderConfig = {
    name: 'B2B Access Hero',
    inputs: [],
};

const builderConfig: BuilderConfig<Props> = {
    component: B2BAccessHero,
    config: B2BAccessHeroBuilderConfig,
};

export default builderConfig;
